
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35443',
  depVersions: {
  "documents-public-ui": "static-1.35443",
  "atom": "static-1.5494",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2899",
  "client-types": "static-1.505",
  "cssUtils": "static-1.1037",
  "customer-data-filters-ui": "static-1.41214",
  "customer-data-objects": "static-1.8109",
  "customer-data-property-utils": "static-1.8464",
  "documents-lib": "static-1.35448",
  "emoji-mart": "static-3.6",
  "flux-actions": "static-1.378",
  "FormsCommonComponents": "static-1.86743",
  "FormUrlGenerator": "static-2.5129",
  "foundations-theming-specialty": "static-1.2613",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6006",
  "hs-test-utils": "static-1.8454",
  "hub-http": "static-1.6625",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12213",
  "HubStyleTokens": "static-2.11906",
  "I18n": "static-7.1691",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6864",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7566",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3303",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5796",
  "quartz": "static-1.7587",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17149",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5624",
  "react-virtualized": "static-2.111",
  "reference-resolvers": "static-1.8594",
  "reference-resolvers-lite": "static-1.8521",
  "reporting-data": "static-1.69180",
  "reporting-reports": "static-1.68856",
  "reporting-snowflake": "static-1.57796",
  "reporting-testing-lib": "static-1.11113",
  "reporting-visualizations": "static-1.61254",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9374",
  "sanitize": "static-1.4888",
  "sanitize-text": "static-1.8572",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2144",
  "signup-constants": "static-1.19838",
  "signup-ui-url-generator": "static-2.8475",
  "StyleGuideUI": "static-3.512",
  "superstore": "static-1.5175",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5162",
  "ui-addon-form-validation": "static-1.11338",
  "ui-asset-management-lib": "static-1.11518",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8852",
  "usage-tracker": "static-1.7729",
  "usage-tracker-container": "static-1.7719",
  "usage-tracker-core": "static-1.7579",
  "viral-links-lib": "static-1.7496",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10061",
  "foundations-components": "static-1.8657",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1365",
  "quartz-core": "static-1.6806",
  "quick-fetch": "static-1.4193",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5085",
  "ui-addon-i18n": "static-1.11562",
  "ui-addon-upgrades": "static-9.18508",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3864",
  "quartz-webpack": "static-1.3811",
  "foundations-assets": "static-1.5301",
  "foundations-theming": "static-1.4897",
  "hub-http-janus": "static-1.896",
  "hub-http-shared-msw-handlers": "static-1.10805",
  "hubspotter-http": "static-1.4929",
  "sassPrefix": "static-1.304",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43988",
  "customer-data-filters-ui-msw-helpers": "static-1.23649",
  "customer-data-objects-ui-components": "static-1.13445",
  "customer-data-reference-ui-components": "static-1.13583",
  "customer-data-ui-utilities": "static-1.10248",
  "events-data-lib": "static-1.663",
  "framework-builder-read-service-client": "static-1.4290",
  "hs-resources": "static-1.611",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3742",
  "inbound-db-properties-service-client": "static-1.4110",
  "multi-account-reference-resolvers": "static-1.1420",
  "onboarding-scopes": "static-1.6868",
  "onboarding-tours": "static-1.17304",
  "pulse": "static-1.1054",
  "reporting-datasets-permissions-lib": "static-1.14667",
  "segments-client-types": "static-1.11960",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2948",
  "trellis-components": "static-1.2967",
  "trellis-theming": "static-1.1397",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1262",
  "ui-business-units-lib": "static-1.9511",
  "usage-tracker-session-replay": "static-1.5415",
  "ai-components-ui-library": "static-1.9921",
  "ContentUtils": "static-1.69342",
  "customer-data-properties": "static-1.52881",
  "forms-ai-lib": "static-1.4900",
  "forms-utils-lib": "static-1.13249",
  "foundations-components-test-utils": "static-1.6140",
  "react-dnd-compat": "static-1.5027",
  "react-tinymce": "static-1.56169",
  "tinymce-config": "static-2.55295",
  "ui-gdpr-components": "static-1.10649",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3882",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3565",
  "msw": "static-1.39",
  "msw-config": "static-1.17",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.362",
  "ui-fonts": "static-1.1168",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4724",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1252",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1961",
  "external-options-client-types": "static-1.4411",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1262",
  "frontend-preferences-client": "static-1.8334",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4118",
  "reporting-client-types": "static-1.2781",
  "apollo-stack-hubspot": "static-3.98",
  "growth-payments-core": "static-1.26394",
  "hubspot-apollo-client": "static-1.5290",
  "foundations-components-legacy": "static-1.1682",
  "quartz-routing": "static-1.1017",
  "hs-story-utils": "static-1.9841",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.652",
  "seat-types-lib": "static-1.939",
  "timezone-utils": "static-2.5647",
  "react-create-root-preference": "static-1.88",
  "bend-plugin-foundations-components": "static-1.4926",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "opentelemetry-fe-types": "static-1.200",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.575",
  "quartz-test": "static-1.1262",
  "quartz-tracking": "static-1.966",
  "bend-plugin-chirp-manifest": "static-1.495",
  "chirp-fetch": "static-1.2316",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6559",
  "ts-schema": "static-1.4362",
  "bender-build-tools": "static-1.3513",
  "bend-plugin-foundations-theming": "static-1.3380",
  "restore-request-side-panel-lib": "static-1.1913",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5019",
  "conditional-properties-service-client": "static-1.4084",
  "crm-pipelines-api-client-types": "static-1.4415",
  "event-emitter": "static-1.1375",
  "fdsr-migration-layer": "static-1.428",
  "multi-currency-client-types": "static-1.3979",
  "getting-started-shared-tasks": "static-1.19460",
  "growth-data-modal": "static-1.6049",
  "growth-onboarding-confetti": "static-1.3479",
  "growth-onboarding-next-action-utils": "static-1.2885",
  "navigation-components": "static-1.19058",
  "onboarding-tours-client": "static-1.5519",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-react": "static-3.10690",
  "ui-shepherd-tracker": "static-1.8071",
  "ui-universal-auth": "static-1.9619",
  "user-context": "static-1.5477",
  "bend-plugin-pulse": "static-1.557",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6864",
  "stylex-utils": "static-1.158",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "hubspotter-http-shared-msw-handlers": "static-1.10803",
  "magpie-lib": "static-1.5851",
  "navigation-messaging": "static-1.8385",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23498",
  "copilot-toolkit": "static-1.12043",
  "cms-field-types": "static-1.5228",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17298",
  "calling-global-api": "static-1.66011",
  "calling-internal-common": "static-1.31738",
  "calling-lifecycle-internal": "static-1.67393",
  "calling-lifecycle-messages": "static-1.59686",
  "commerce-products-lib": "static-1.10762",
  "crm-index-visualization-core": "static-1.4678",
  "crm-links": "static-1.6719",
  "customer-data-properties-shared-msw-handlers": "static-1.10132",
  "file-manager-components": "static-1.24739",
  "formula-editor": "static-1.14933",
  "framework-data-schema-resolvers": "static-1.7309",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4492",
  "meetings-icalendar-utils-lib": "static-1.1053",
  "object-builder-ui-client": "static-1.49911",
  "pipeline-validation-client-types": "static-1.4251",
  "property-value-citations": "static-1.3495",
  "smart-data-capture-core": "static-1.351",
  "smart-property-lib": "static-1.8522",
  "tiered-pricing": "static-1.2142",
  "topics-actions-lib": "static-1.591",
  "trial-components-library": "static-1.14293",
  "ui-addon-iframeable": "static-1.9494",
  "zustand": "static-1.88",
  "final-form": "static-1.82",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20468",
  "tinymce-themes": "static-1.57265",
  "data-token-picker": "static-1.17042",
  "hub-http-contrib": "static-1.3443",
  "interframe": "static-3.5157",
  "tinymce-data": "static-1.41380",
  "tinymce-plugins": "static-1.58409",
  "ui-addon-sales-email": "static-1.5619",
  "ui-addon-opt": "static-4.8795",
  "hubspot-apollo-cache": "static-1.749",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.564",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.116",
  "purchase-motions-api": "static-1.6562",
  "onboarding-data-sync-lib": "static-1.2742",
  "growth-onboarding-next-action-components": "static-1.2913",
  "user-context-client": "static-1.4924",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5311",
  "nest": "static-1.650",
  "reactive-lib": "static-1.1139",
  "simple-logging-lib": "static-1.3468",
  "unified-auth-core-lib": "static-1.1415",
  "getting-started-shared-tasks-store": "static-1.18578",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2005",
  "integrations-error-boundary-lib": "static-1.14713",
  "integrations-tracking-lib": "static-1.6027",
  "native-integrations-shared-strings": "static-1.8178",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10787",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1133",
  "calling-error-reporting": "static-1.31745",
  "shared-worker-versioning": "static-1.11457",
  "calling-usage-tracker": "static-1.6950",
  "voice-sms-access-library": "static-1.2311",
  "customer-data-tracking": "static-1.7288",
  "commerce-permissions": "static-1.1192",
  "products-iframe-lib": "static-1.8798",
  "products-ui-components-shared-msw-handlers": "static-1.11187",
  "framework-data-schema-quick-fetch": "static-1.7214",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10888",
  "sales-views-client-types": "static-1.4675",
  "location-customization-utils-lib": "static-1.10315",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4558",
  "poll-commands": "static-1.3888",
  "video-components-external": "static-1.12328",
  "video-data-lib": "static-1.35986",
  "bark-lib": "static-1.16946",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6304",
  "react-codemirror": "static-1.11055",
  "data-agent-kit": "static-1.802",
  "feedback-loader": "static-1.29974",
  "fsm": "static-1.4170",
  "policy-lib": "static-1.7222",
  "react-colorpicker": "static-2.10628",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10951",
  "embedded-academy-lib": "static-1.15833",
  "hubs-service-types": "static-1.1680",
  "nudge-client-utils": "static-1.3315",
  "salesImages": "static-1.674",
  "FileManagerLib": "static-1.40379",
  "NamespacedHubStyle": "static-2.9326",
  "FileManagerCore": "static-1.40238",
  "content-assistance-lib": "static-1.8342",
  "layout-dnd-components": "static-1.13130",
  "layout-dnd-utils": "static-1.12105",
  "ui-addon-emoji-picker": "static-1.10283",
  "ui-brand-identity-lib": "static-1.16789",
  "InboxConnectUtils": "static-4.15747",
  "meetings-connect-utils-lib": "static-1.8032",
  "breeze-engine-chat-components": "static-1.983",
  "breeze-engine-core": "static-1.1283",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3426",
  "adobe-sign-auth-lib": "static-1.663",
  "ads-unified-auth-lib": "static-1.1764",
  "custom-vendor-connection-lib": "static-1.183",
  "google-sheets-integration-lib": "static-1.1228",
  "microsoft-drive-auth-lib": "static-1.390",
  "surveymonkey-integration-lib": "static-1.759",
  "slack-ui-library": "static-1.10813",
  "calling-orchestration-schema": "static-1.37088",
  "crm-record-cards-service-types": "static-1.3834",
  "content-media-composition-data-lib": "static-1.13474",
  "content-media-compositions": "static-2.17481",
  "media-bridge-lib": "static-1.19557",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16566",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4921",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15293",
  "nudge-custom-function-registry": "static-1.3072",
  "nudge-renderer-utils": "static-1.3391",
  "whisper-core-api": "static-1.7533",
  "audio-components": "static-1.6490",
  "FileManagerImages": "static-1.37890",
  "video-components": "static-1.14330",
  "breeze-artifacts-sdk": "static-1.675",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4932",
  "video-embed": "static-1.36820",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29505",
  "ContentData": "static-1.69417",
  "layout-data-lib": "static-1.10430",
  "academy-service-client": "static-1.4108",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4810",
  "trellis-ecosystem": "static-1.7769",
  "ui-addon-react-router-dom": "static-1.9945",
  "wootric-nps": "static-1.7264",
  "social-insights-client-types": "static-1.22833",
  "outpost": "static-1.4550",
  "growth-onboarding-feedback-components": "static-1.6999",
  "advanced-menus-core": "static-1.15728",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10789",
  "ui-memberships-settings-lib": "static-1.35078",
  "marketplace-ui-apps-core": "static-1.19487",
  "marketplace-ui-common": "static-1.20955",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15727",
  "simple-menus-lib": "static-1.17244",
  "settings-ui-lib": "static-1.12945",
  "developer-experience-shared-components": "static-1.10953",
  "immutable-less": "static-1.5066",
  "marketplace-ui-client-types": "static-1.18362",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4332",
  "ai-settings-ui-library": "static-1.8495",
  "nav-meta": "static-1.30695",
  "ui-product-approvals-common": "static-1.1424",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3721"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35443",
  "atom": "/atom/static-1.5494",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2899",
  "client-types": "/client-types/static-1.505",
  "cssUtils": "/cssUtils/static-1.1037",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41214",
  "customer-data-objects": "/customer-data-objects/static-1.8109",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "documents-lib": "/documents-lib/static-1.35448",
  "emoji-mart": "/emoji-mart/static-3.6",
  "flux-actions": "/flux-actions/static-1.378",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86743",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5129",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2613",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6006",
  "hs-test-utils": "/hs-test-utils/static-1.8454",
  "hub-http": "/hub-http/static-1.6625",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12213",
  "HubStyleTokens": "/HubStyleTokens/static-2.11906",
  "I18n": "/I18n/static-7.1691",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6864",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7566",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3303",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5796",
  "quartz": "/quartz/static-1.7587",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17149",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5624",
  "react-virtualized": "/react-virtualized/static-2.111",
  "reference-resolvers": "/reference-resolvers/static-1.8594",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8521",
  "reporting-data": "/reporting-data/static-1.69180",
  "reporting-reports": "/reporting-reports/static-1.68856",
  "reporting-snowflake": "/reporting-snowflake/static-1.57796",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11113",
  "reporting-visualizations": "/reporting-visualizations/static-1.61254",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9374",
  "sanitize": "/sanitize/static-1.4888",
  "sanitize-text": "/sanitize-text/static-1.8572",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2144",
  "signup-constants": "/signup-constants/static-1.19838",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8475",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "superstore": "/superstore/static-1.5175",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5162",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11338",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11518",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8852",
  "usage-tracker": "/usage-tracker/static-1.7729",
  "usage-tracker-container": "/usage-tracker-container/static-1.7719",
  "usage-tracker-core": "/usage-tracker-core/static-1.7579",
  "viral-links-lib": "/viral-links-lib/static-1.7496",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10061",
  "foundations-components": "/foundations-components/static-1.8657",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1365",
  "quartz-core": "/quartz-core/static-1.6806",
  "quick-fetch": "/quick-fetch/static-1.4193",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5085",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11562",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18508",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3864",
  "quartz-webpack": "/quartz-webpack/static-1.3811",
  "foundations-assets": "/foundations-assets/static-1.5301",
  "foundations-theming": "/foundations-theming/static-1.4897",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10805",
  "hubspotter-http": "/hubspotter-http/static-1.4929",
  "sassPrefix": "/sassPrefix/static-1.304",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43988",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23649",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13445",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13583",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10248",
  "events-data-lib": "/events-data-lib/static-1.663",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4290",
  "hs-resources": "/hs-resources/static-1.611",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3742",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4110",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1420",
  "onboarding-scopes": "/onboarding-scopes/static-1.6868",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "pulse": "/pulse/static-1.1054",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14667",
  "segments-client-types": "/segments-client-types/static-1.11960",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2948",
  "trellis-components": "/trellis-components/static-1.2967",
  "trellis-theming": "/trellis-theming/static-1.1397",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1262",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9511",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5415",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9921",
  "ContentUtils": "/ContentUtils/static-1.69342",
  "customer-data-properties": "/customer-data-properties/static-1.52881",
  "forms-ai-lib": "/forms-ai-lib/static-1.4900",
  "forms-utils-lib": "/forms-utils-lib/static-1.13249",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6140",
  "react-dnd-compat": "/react-dnd-compat/static-1.5027",
  "react-tinymce": "/react-tinymce/static-1.56169",
  "tinymce-config": "/tinymce-config/static-2.55295",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3882",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3565",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.17",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.362",
  "ui-fonts": "/ui-fonts/static-1.1168",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4724",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1252",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1961",
  "external-options-client-types": "/external-options-client-types/static-1.4411",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1262",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8334",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4118",
  "reporting-client-types": "/reporting-client-types/static-1.2781",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "growth-payments-core": "/growth-payments-core/static-1.26394",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5290",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1682",
  "quartz-routing": "/quartz-routing/static-1.1017",
  "hs-story-utils": "/hs-story-utils/static-1.9841",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.652",
  "seat-types-lib": "/seat-types-lib/static-1.939",
  "timezone-utils": "/timezone-utils/static-2.5647",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4926",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.200",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.575",
  "quartz-test": "/quartz-test/static-1.1262",
  "quartz-tracking": "/quartz-tracking/static-1.966",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.495",
  "chirp-fetch": "/chirp-fetch/static-1.2316",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6559",
  "ts-schema": "/ts-schema/static-1.4362",
  "bender-build-tools": "/bender-build-tools/static-1.3513",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3380",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1913",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4084",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4415",
  "event-emitter": "/event-emitter/static-1.1375",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.428",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3979",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19460",
  "growth-data-modal": "/growth-data-modal/static-1.6049",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3479",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2885",
  "navigation-components": "/navigation-components/static-1.19058",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10690",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8071",
  "ui-universal-auth": "/ui-universal-auth/static-1.9619",
  "user-context": "/user-context/static-1.5477",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.557",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6864",
  "stylex-utils": "/stylex-utils/static-1.158",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10803",
  "magpie-lib": "/magpie-lib/static-1.5851",
  "navigation-messaging": "/navigation-messaging/static-1.8385",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23498",
  "copilot-toolkit": "/copilot-toolkit/static-1.12043",
  "cms-field-types": "/cms-field-types/static-1.5228",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17298",
  "calling-global-api": "/calling-global-api/static-1.66011",
  "calling-internal-common": "/calling-internal-common/static-1.31738",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67393",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59686",
  "commerce-products-lib": "/commerce-products-lib/static-1.10762",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4678",
  "crm-links": "/crm-links/static-1.6719",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10132",
  "file-manager-components": "/file-manager-components/static-1.24739",
  "formula-editor": "/formula-editor/static-1.14933",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7309",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4492",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1053",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49911",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4251",
  "property-value-citations": "/property-value-citations/static-1.3495",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.351",
  "smart-property-lib": "/smart-property-lib/static-1.8522",
  "tiered-pricing": "/tiered-pricing/static-1.2142",
  "topics-actions-lib": "/topics-actions-lib/static-1.591",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9494",
  "zustand": "/zustand/static-1.88",
  "final-form": "/final-form/static-1.82",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20468",
  "tinymce-themes": "/tinymce-themes/static-1.57265",
  "data-token-picker": "/data-token-picker/static-1.17042",
  "hub-http-contrib": "/hub-http-contrib/static-1.3443",
  "interframe": "/interframe/static-3.5157",
  "tinymce-data": "/tinymce-data/static-1.41380",
  "tinymce-plugins": "/tinymce-plugins/static-1.58409",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5619",
  "ui-addon-opt": "/ui-addon-opt/static-4.8795",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.749",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.564",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.116",
  "purchase-motions-api": "/purchase-motions-api/static-1.6562",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2742",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2913",
  "user-context-client": "/user-context-client/static-1.4924",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5311",
  "nest": "/nest/static-1.650",
  "reactive-lib": "/reactive-lib/static-1.1139",
  "simple-logging-lib": "/simple-logging-lib/static-1.3468",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1415",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18578",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2005",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14713",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6027",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8178",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10787",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1133",
  "calling-error-reporting": "/calling-error-reporting/static-1.31745",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11457",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6950",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2311",
  "customer-data-tracking": "/customer-data-tracking/static-1.7288",
  "commerce-permissions": "/commerce-permissions/static-1.1192",
  "products-iframe-lib": "/products-iframe-lib/static-1.8798",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11187",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7214",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10888",
  "sales-views-client-types": "/sales-views-client-types/static-1.4675",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10315",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4558",
  "poll-commands": "/poll-commands/static-1.3888",
  "video-components-external": "/video-components-external/static-1.12328",
  "video-data-lib": "/video-data-lib/static-1.35986",
  "bark-lib": "/bark-lib/static-1.16946",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6304",
  "react-codemirror": "/react-codemirror/static-1.11055",
  "data-agent-kit": "/data-agent-kit/static-1.802",
  "feedback-loader": "/feedback-loader/static-1.29974",
  "fsm": "/fsm/static-1.4170",
  "policy-lib": "/policy-lib/static-1.7222",
  "react-colorpicker": "/react-colorpicker/static-2.10628",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10951",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15833",
  "hubs-service-types": "/hubs-service-types/static-1.1680",
  "nudge-client-utils": "/nudge-client-utils/static-1.3315",
  "salesImages": "/salesImages/static-1.674",
  "FileManagerLib": "/FileManagerLib/static-1.40379",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9326",
  "FileManagerCore": "/FileManagerCore/static-1.40238",
  "content-assistance-lib": "/content-assistance-lib/static-1.8342",
  "layout-dnd-components": "/layout-dnd-components/static-1.13130",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12105",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10283",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16789",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15747",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8032",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.983",
  "breeze-engine-core": "/breeze-engine-core/static-1.1283",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3426",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.663",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1764",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.183",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1228",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.390",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.759",
  "slack-ui-library": "/slack-ui-library/static-1.10813",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37088",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13474",
  "content-media-compositions": "/content-media-compositions/static-2.17481",
  "media-bridge-lib": "/media-bridge-lib/static-1.19557",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16566",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4921",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15293",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3072",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3391",
  "whisper-core-api": "/whisper-core-api/static-1.7533",
  "audio-components": "/audio-components/static-1.6490",
  "FileManagerImages": "/FileManagerImages/static-1.37890",
  "video-components": "/video-components/static-1.14330",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.675",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4932",
  "video-embed": "/video-embed/static-1.36820",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29505",
  "ContentData": "/ContentData/static-1.69417",
  "layout-data-lib": "/layout-data-lib/static-1.10430",
  "academy-service-client": "/academy-service-client/static-1.4108",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4810",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7769",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9945",
  "wootric-nps": "/wootric-nps/static-1.7264",
  "social-insights-client-types": "/social-insights-client-types/static-1.22833",
  "outpost": "/outpost/static-1.4550",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6999",
  "advanced-menus-core": "/advanced-menus-core/static-1.15728",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10789",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35078",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19487",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20955",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15727",
  "simple-menus-lib": "/simple-menus-lib/static-1.17244",
  "settings-ui-lib": "/settings-ui-lib/static-1.12945",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10953",
  "immutable-less": "/immutable-less/static-1.5066",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18362",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4332",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8495",
  "nav-meta": "/nav-meta/static-1.30695",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1424",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3721"
}
};
